<style lang="scss" scoped>
.stepOne{
  background-color: #ebf6ff;
  border: 1px dashed #7bbcff;
  height: 434px;
  width: 674px;
  margin: 30px auto;
  p{
    &:hover{
      cursor: pointer;
    }
  }
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;

}
.mockEntrance{
  align-self: center;
}
.mainTips{
  font-size: 16px;
  font-weight: bold;
  padding: 0 10px;
  ::v-deep .el-button{
    span{
      border-bottom: 1px solid #409eff;
    }
  }
}
.subTips{
  padding: 0 10px;
  font-size: 14px;
  line-height: 16px;
}
</style>
<template>
  <div class="stepOne">
    <!-- <p>请完成模拟考试以进入下一步</p> -->
    <p class="mockEntrance">
      <p class="mainTips">为了帮助您了解整个考试流程以及操作，确保考试能够顺利进行，请<el-button @click="handleEnterPractice" type="text" >点击此处</el-button>完成考前测试。</p>
      <p class="subTips">本考前测试模拟您将参加的考试所包含的所有题型，如选择题、判断题、填空题、编程题等，让您能够熟悉在线考试平台的操作，帮助您顺利完成考试。如遇到问题无法解决，可在考前联系技术支持。</p>
    <!-- <el-button @click="handleGoPractice">点击直接跳过</el-button> -->

    </p>
  </div>
</template>
<script>

import { mapState } from 'vuex';
import codepku from '../../../utils/codepku';

export default {
  data() {
 return {
      typeHash: sessionStorage.getItem('hash') || this.$route.hash,
  };
},
  methods: {
    handleGoPractice() {
      // this.$message.success('恭喜您完成了考前测试');
      this.$emit('practiceDone');
    },
    handleEnterPractice() {
      const { href } = this.$router.resolve({
        path: '/mockExam',
        query: {
          category: this.myExam.examination_category_id,
          eeid: this.examinee.examination_examinee_id,
          title: this.myExam.examination_category_title,
          category_type: this.myExam.examination_category_category,
          match_category: this.myExam.match_category,
          type:'simulation'
        },
      });
      // window.open(href, '_blank');
      // window.open(href, `MockExam${codepku.genUniqueId()}`);
      window.open(`${href}${this.typeHash}`, 'mockExam-window');
    },
  },

  components: {},
  created() {},
  mounted() {

  },
  props: {
    deviceStatus: {
      type: Object,
    },
    checkPassed: {
      type: [Boolean],
    },
  },
  watch: {},
   computed: {
    ...mapState({
      myExam: 'myExam',
      examinee: 'examinee',
    }),
  },
};
</script>
